// src/icons.js
// Icons used via react-icons:
// - BI : BoxIcons - MIT License
// - BS : Bootstrap Icons - MIT License
// - FI : Feather Icons – MIT License
// - MD : Material Design Icons – Apache License 2.0
// - TB : Tabler Icons – MIT License
// - SL : Simple Line Icons - MIT License
// - PI : Phosphore Icons - MIT License
// - IO5: Ionicons 5 - MIT License
// - RX : Radix Icons - MIT License
// Source: https://react-icons.github.io/react-icons/
import { BiWorld } from "react-icons/bi";
import { FiEdit2, FiTrash2, FiPlus, FiUser, FiMail, FiX, FiSun, FiMoon, FiZoomIn, FiZoomOut } from 'react-icons/fi';
import { MdNavigateNext, MdCloudDownload, MdDirectionsBus, MdBlock, MdMap, MdPhoneIphone, MdPregnantWoman, MdOutlineVolunteerActivism, MdOutlineContactPhone, MdPolicy } from 'react-icons/md';
import { TbSettings, TbSettingsOff, TbHealthRecognition, TbContract } from "react-icons/tb";
import { BsPersonVcard } from "react-icons/bs";
import { SlCalender, SlQuestion } from "react-icons/sl";
import { PiSneakerMove } from "react-icons/pi";
import { IoInformationCircleOutline, IoNewspaperOutline } from "react-icons/io5";
import { RxReset } from "react-icons/rx";
export const Icons = {
    World: BiWorld,
    Edit: FiEdit2,
    Delete: FiTrash2,
    Add: FiPlus,
    User: FiUser,
    Mail: FiMail,
    Bus: MdDirectionsBus,
    Block: MdBlock,
    Policy: MdPolicy,
    // Info: MdInfo,
    Map: MdMap,
    X: FiX,
    Phone: MdPhoneIphone,
    Sun: FiSun,
    Moon: FiMoon,
    Cog: TbSettings,
    NoCog: TbSettingsOff,
    MemberCard: BsPersonVcard,
    Pregnant: MdPregnantWoman,
    Calender: SlCalender,
    SportOffer: PiSneakerMove,
    Contact: MdOutlineContactPhone,
    Health: TbHealthRecognition,
    Info: IoInformationCircleOutline,
    News: IoNewspaperOutline,
    Freiwilligkeit: MdOutlineVolunteerActivism,
    Stellenangebot: TbContract,
    Question: SlQuestion,
    ZoomIn: FiZoomIn,
    ZoomOut: FiZoomOut,
    Reset: RxReset,
    Download: MdCloudDownload,
    ArrowRight: MdNavigateNext
};



// AI : Ant Design Icons
// BS : Bootstrap Icons
// BI : BoxIcons
// CG : css.gg
// DI : Devicons
// FI : Feather
// FC : Flat Color Icons
// GO : Github Octicons Icons
// HI : Heroicons
// HI2: Heroicons 2
// LIA: Icons8 Line Awesome
// IO : Ionicons 4
// IO5: Ionicons 5
// PI : Phosphor Icons
// RX : Radix Icons
// SL : Simple Line Icons
// TB : Tabler Icons
// TFI: Themify Icons
//  
